module.exports = __webpack_public_path__ + "static/Docker_Balloon-92f20756adb176253e1227c0650f2513.png";